export var PNL_REPORT_DATA = "PNL_REPORT_DATA";
export var PNL_SUMMARIZE = "PNL_SUMMARIZE";
export var LONG_TERM_QUANTITY = "LONG_TERM_QUANTITY";
export var PNL_SEARCH = "PNL_SEARCH";
export var STOCK_INDEX = "STOCK_INDEX";
